// src/components/MoveNoteModal.jsx

import React from 'react';

export default function MoveNoteModal({
  patients,
  onMove,
  onClose,
  currentPatientId,
  noteId,
}) {
  const [selectedId, setSelectedId] = React.useState('');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm px-4">
      <div className="bg-white dark:bg-zinc-900 text-gray-800 dark:text-gray-100 rounded-2xl shadow-2xl p-6 w-full max-w-md animate-scale-in transition-all">
        <h3 className="text-xl font-semibold mb-4">🔁 Move Note to Another Patient</h3>

        <label className="block font-medium mb-1">Select a patient:</label>
        <select
          className="w-full p-3 rounded-lg border border-zinc-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm"
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          <option value="" disabled>Select a patient...</option>
          {patients
            .filter((p) => p.id !== currentPatientId)
            .map((p) => (
              // --- THIS IS THE FIX ---
              // Display the patient's name instead of their room number.
              <option key={p.id} value={p.id}>
                {p.firstName} {p.lastName} ({p.setting || 'N/A'}) – CC: {p.chiefComplaint}
              </option>
            ))}
        </select>

        <div className="flex justify-end mt-6 gap-3">
          <button
            onClick={() => {
              if (selectedId) onMove(noteId, selectedId);
            }}
            disabled={!selectedId} // Disable button until a patient is selected
            className="px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-semibold transition disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Move Note
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-zinc-200 hover:bg-zinc-300 text-gray-800 dark:bg-zinc-700 dark:text-white dark:hover:bg-zinc-600 font-medium transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
